export default {
  'Resize for': 'Ajustar o tamanho',
  'Add 10 videos at most': 'Adicione no máximo 10 vídeos.',
}